module.exports = __webpack_public_path__ + "img/reconstruccion-canos-sa.3457dd4f.jpg";